import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import BootstrapVue from 'bootstrap-vue'
import '@/plugins/appUtils'
import '@/plugins/eventBus'
//import SuiVue from 'semantic-ui-vue'
//import PortalVue from 'portal-vue'
//import VueScrollTo from 'vue-scrollto'
//import TextareaAutosize from 'vue-textarea-autosize'

const requirePlugin = require.context(
    './',
    false,
    /Base[A-Z]\w+\.(vue|js)$/
)

requirePlugin.keys().forEach(fileName => {
    const pluginConfig = requirePlugin(fileName)

    const pluginName = upperFirst(
        camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    )

    Vue.use(pluginConfig.default)
})

Vue.use(BootstrapVue)
//Vue.use(SuiVue)
//Vue.use(PortalVue)
//Vue.use(VueScrollTo)
//Vue.use(TextareaAutosize)



